<template>
    <div>
        <v-card>
        <v-card-title primary-title>
            <h1>Cambiar marca</h1>
        </v-card-title>
        <v-card-text>
            <v-container grid-list-md>
            <v-select 
                label="Marca"
                v-model="makerSelected"
                outline
                :items="this.makers"
                item-text="name"
                item-value="id"
                >
            </v-select>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
                color="blue darken-1" 
                @click="close()"
                flat>Cancelar</v-btn>
            <v-btn 
                color="success"
                :disabled="makerSelected == 1"
                @click="changeMarker()"
                 >Guardar</v-btn>
        </v-card-actions>
        </v-card>
    </div>
  </template>
  <script>
import { changeMaker } from '@/services/products';
  import { getCountries, getMakers } from '../../services/catalogs';
  export default {
    props: ['product'],
    data() {
      return {
        makers: [],
        makerSelected: 1
      };
    },
    watch: {
        product() {
            console.log(this.product);
            if(this.product){
                this.makerSelected = this.product.maker_id
            }
        }
    },
    methods: {
        close() {
           this.$emit('close') 
        },
        async changeMarker(){
            const maker = this.makers.find(it => it.id === this.makerSelected)
            const params = {
                idProduct: this.product.product_id,
                serial_number: this.product.serial_number,
                idMaker: this.makerSelected,
                maker: maker.name
            }
            const response = await changeMaker(params);
            if(response.data.statusCode === 200){
                this.product.maker_id = maker.id
                this.product.maker_name = maker.name
                this.$emit('product-update', this.product)
            }else{
                this.$emit('error', response.data.friendlyMessage[0]);
            }
            
        }
    },
    mounted() {
      getMakers()
        .then((results) => {
          this.makers = results.data;
        })
        .catch((error) => {
          this.$emit('error', error.message);
        });
    },
  };
  </script>
  
  